import clsx from "clsx";
import { useFormik } from "formik";
import debounce from "lodash/debounce";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CalendarPicker from "../../../components/CalenderPicker";
import Dropdown from "../../../components/Dropdown";
import { Input } from "../../../components/Input";
import LeftSide from "../../../components/LeftSide";
import ModalAction from "../../../components/ModalAction";
import ModalSkeleton from "../../../components/ModalSkeleton";
import PhoneInput from "../../../components/PhoneInput";
import ShowCalculation from "../../../components/ShowCalculation";
import StartAndEndTime from "../../../components/StartAndEndTime";
import {
  BadmintonIcon,
  BookingTypeIcon,
  CorporateIcon,
  DarkMailIcon,
  LocationIcon,
  ReceivePaymentIcon,
  UserOutline,
} from "../../../constant";
import { bookingTypeOptions, paymentMethods } from "../../../data";
import {
  addMinutes,
  convertToAmPm,
  formatNumberWithCommas,
} from "../../../helpers";
import {
  dayOfWeek,
  generateIntervals,
  getCourtTimings,
  getRelatedCourts,
  getSelectedCourt,
  splitAndMarkBlockedIntervals,
} from "../../../lib";
import useApi from "../../../useApi";
import classes from "./RescheduleBooking.module.css";
const durations = [
  { label: "1 Hour", value: 60 },
  { label: "30 Minutes", value: 30 },
];
const CourtDayOfWeekEnum = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
};

const validationSchema = Yup.object()
  .shape({
    name: Yup.string().required("Name is required"),
    phoneNumber: Yup.string()
      .required("Phone number is required")
      .matches(/^\+?[0-9]{1,4}[0-9]{10}$/, "Invalid phone number format"),
    email: Yup.string().email("Invalid email address"),
    bookingDate: Yup.string().required("Date is required"),
    location: Yup.string().required("Location is required"),
    court: Yup.string().required("Court is required"),
    bookingType: Yup.number().required("Booking type is required"),
    paymentMethod: Yup.string().required("Payment method is required"),
    // timeSlots: Yup.array().when(["bookingType"], {
    //   is: (bookingType) => bookingType === 1 || bookingType === 5,
    //   then: () => Yup.array().min(1, "At least one time slot must be selected"),
    //   otherwise: () => Yup.array(),
    // }),
    startTime: Yup.mixed().when(["bookingType"], {
      is: (bookingType) => bookingType !== 1 && bookingType !== 5,
      then: () => Yup.mixed().required("Start time is required").nullable(),
      otherwise: () => Yup.mixed().nullable(),
    }),
    endTime: Yup.mixed().when(["bookingType"], {
      is: (bookingType) => bookingType !== 1 && bookingType !== 5,
      then: () => Yup.mixed().required("End time is required").nullable(),
      otherwise: () => Yup.mixed().nullable(),
    }),
    corporateId: Yup.mixed().when("bookingType", {
      is: 5,
      then: () => Yup.number().required("Please select a corporation"),
      otherwise: () => Yup.mixed().nullable(),
    }),
  })
  .test("time-slots-validation", "", function (value) {
    if (!value.startTime || !value.endTime) {
      return this.createError({
        path: "timeSlots",
        message: "Please select both start and end time",
      });
    }
    // if (value.bookingType === 1 || value.bookingType === 5) {
    //   if (!value.timeSlots || value.timeSlots.length === 0) {
    //     return this.createError({
    //       path: "timeSlots",
    //       message: "At least one time slot must be selected",
    //     });
    //   }
    // } else {
     
    // }
    return true;
  });

const initialValues = {
  name: "",
  phoneNumber: "",
  email: "",
  location: null,
  court: null,
  bookingType: null,
  bookingDate: moment().format("YYYY-MM-DD"),
  timeSlots: [],
  discountAmount: 0,
  paymentMethod: null,
  totalPayment: 0,
  paymentCollection: 0,
  duration: null,
  attachment: null,
  startTime: null,
  endTime: null,
  corporateId: null,
};

const RescheduleBookingModal = ({
  show,
  setShow,
  onSubmit,
  isApiCall,
  data,
  subTitle = "",

}) => {
  const [loading, setLoading] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]);
  const [blockedSlots, setBlockedSlots] = useState([]);
  let { locations } = useSelector((state) => state?.allPreLoadedApis);
  const [userList, setUserList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const userDropdownRef = useRef(null);
  const { getAllBlockedSlots, getUserByName, getAllCorporates } = useApi();
  const [userSelected, setUserSelected] = useState(false);
  const [corporateOptions, setCorporateOptions] = useState([]);
  const [isLoadingCorporates, setIsLoadingCorporates] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1);

  console.log("Locations", locations);
  const getAllSlotsApi = async (date, courtId) => {
    setLoading(true);

    const response = await getAllBlockedSlots({
      companyDetailID: 1,
      courtId: courtId,
      date,
    });
    if (response?.data?.headers?.error === 200) {
      console.log("data blocked slots", response?.data?.body?.items);
      setBlockedSlots(response?.data?.body?.items);
      return response?.data?.body?.items;
    }
    if (response?.data?.headers?.error !== 200) {
      toast.error(response?.data?.headers?.message);
    }
  };

  // Debounced search function
  const debouncedSearch = useCallback(
    debounce(async (term) => {
      if (term.length < 2) {
        setUserList([]);
        // Don't hide dropdown here, let the input change handler do it
        return;
      }

      setSearchLoading(true);
      try {
        await getUserByNameApi(term);
        setShowUserDropdown(true);
      } catch (error) {
        console.error("Error searching users:", error);
        toast.error("Failed to search users");
      } finally {
        setSearchLoading(false);
      }
    }, 500),
    []
  );

  const getUserByNameApi = async (params) => {
    const response = await getUserByName({
      id: null,
      search: params,
      pageNumber: 1,
      pageSize: 100000, // Limit to 100000 results for better performance
      showInactive: true,
      showUpcoming: true,
    });

    if (response?.data?.headers?.error === 200) {
      setUserList(response?.data?.body?.items || []);
    }
  };

  const fetchCorporates = async () => {
    setIsLoadingCorporates(true);
    try {
      const response = await getAllCorporates({
        search: "",
        pageNumber: 1,
        pageSize: 100,
      });

      if (response?.data?.headers?.error === 200) {
        const corporateList = response?.data?.body?.items || [];
        // Transform into dropdown options
        setCorporateOptions(corporateList);
      }
    } catch (error) {
      console.error("Error fetching corporations:", error);
      toast.error("Failed to load corporations");
    } finally {
      setIsLoadingCorporates(false);
    }
  };

  console.log("corporateOptions", corporateOptions);
  useEffect(() => {
    if (show) {
      fetchCorporates();
    }
  }, [show]);

  const getCombinedBookingOptions = () => {
    // Base options always visible
    const baseOptions = [
      { label: "Standard", value: 1 },
      { label: "Corporate", value: 2 },
    ];

    return bookingTypeOptions;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      // If Corporate booking type is selected but no corporation is chosen, show error
      if (values.bookingType === 5 && !values.corporateId) {
        setFieldError("corporateId", "Please select a corporation");
        setFieldTouched("corporateId", true);
        setSubmitting(false);
        return; // Don't proceed with submission
      }

      console.log("values", values);
      const params = {
        ...(data && {
          bookingId: data?.bookingId,
        }),

        bookingTypeId: values?.bookingType,

        courtId: values?.court || null,
        bookingDate: values?.bookingDate,
        bookingTimes:[
          {
            bookingStartTime: moment(values.startTime).set('seconds', 0).format("HH:mm:ss"),
            bookingEndTime: moment(values.endTime).set('seconds', 0).format("HH:mm:ss"),
          },
        ],
          // values?.bookingType === 1
          //   ? values?.timeSlots?.map((data) => ({
          //       bookingStartTime: data?.split("-")[0]?.trim(),
          //       bookingEndTime: data?.split("-")[1]?.trim(),
          //     }))
          //   : [
          //       {
          //         bookingStartTime: moment(values.startTime).format("HH:mm:ss"),
          //         bookingEndTime: moment(values.endTime).format("HH:mm:ss"),
          //       },
          //     ],
        totalAmount: +values?.totalPayment,

        // attachment: values?.attachment,
      };
      if (typeof onSubmit === "function") {
        onSubmit(params);
      }
    },
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateField,
  } = formik;
  let calculatedAmount = values?.totalPayment - values?.discountAmount;
  let remainingPayment =
    values?.totalPayment - values?.discountAmount - values?.paymentCollection;
  if (calculatedAmount < 0) calculatedAmount = 0;
  const handleChangeWithTouch = (field) => (value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };

  const derivedDurationFromCourts = (e) => {
    if (!e) return;

    const selectedCourt = getSelectedCourt(values?.location, e);
    if (!selectedCourt?.courtSlotDuration) return;

    const duration = durations?.find(
      (duration) => duration?.value === selectedCourt?.courtSlotDuration
    );

    if (duration?.value) {
      setFieldValue("duration", duration.value);
    }
  };

  const handleCourtChange = (e) => {
    if (!e) return;

    // Set value first
    setFieldValue("court", e);
    derivedDurationFromCourts(e);

    // Reset dependent fields
    setFieldValue("timeSlots", []);
    setFieldValue("totalPayment", 0);
    
    // Clear any court-related errors
    setFieldError("court", undefined);
  };

  let firstTime = 0;

  console.log("values?.court", values?.court);
  useEffect(() => {
    if (values?.duration && firstTime === 0) {
      firstTime = 1;
      setTimeSlots((prev) =>
        prev?.map((data) => ({
          label: `${convertToAmPm(data?.label?.split("-")[0])} - ${addMinutes(
            data?.label?.split("-")[0],
            values?.duration
          )}`,
          value: data?.value,
          ...data,
        }))
      );
    }

    console.log("errors ()", errors);
    if (values?.duration && values?.bookingDate && values?.court) {
      (async () => {
        try {
          const allRelatedTiming = getCourtTimings(
            values?.location,
            values?.court,
            dayOfWeek(values?.bookingDate)
          );

          const blockedAllSlots = await getAllSlotsApi(
            moment(values?.bookingDate)?.format("YYYY-MM-DD"),
            values?.court
          );

          const allPossibleInterval = generateIntervals(
            allRelatedTiming,
            values?.duration,
            getSelectedCourt(values?.location, values?.court)?.courtSlotDuration
          );

          const splittedResult = splitAndMarkBlockedIntervals(
            allPossibleInterval,
            blockedAllSlots
          );

          setTimeSlots(
            splittedResult
              ?.filter((data) => !data?.isBlocked)
              ?.map((data) => ({
                label: `${convertToAmPm(data?.courtStartTime)} - ${convertToAmPm(
                  data?.courtEndTime
                )}`,
                value: `${data?.courtStartTime} - ${data?.courtEndTime}`,
                ...data,
              }))
          );
        } catch (error) {
          console.error("Error fetching slots:", error);
          toast.error("Error fetching available slots");
        }
      })();
    }
  }, [values?.duration, values?.bookingDate, values?.court]);

  useEffect(() => {
    setFieldValue("paymentMethod", paymentMethods[0]?.value);
    setFieldValue("bookingType", bookingTypeOptions[0]?.value);
    setFieldValue("duration", durations[0]?.value);
    setFieldValue("timeSlots", []); // Initialize timeSlots as empty

    console.log("store", "locations", locations);

    if (locations?.length == 1) {
      setFieldValue("location", locations[0]?.locationId);
    }
  }, []);

  const handleTimeChange = (type, time) => {
    console.log("type", type, "time", time);

    if (type === "start") {
      setFieldValue("startTime", time);
      setFieldTouched("startTime", true, true);
      if (values.endTime) {
        const startStr = moment(time).format("HH:mm:ss");
        const endStr = moment(values.endTime).format("HH:mm:ss");
        handleChangeWithTouch("timeSlots")([`${startStr}-${endStr}`]);
        // Clear timeSlots error when both times are selected
        setFieldTouched("timeSlots", true, true);
        setFieldError("timeSlots", undefined);
      }
    } else {
      setFieldValue("endTime", time);
      setFieldTouched("endTime", true, true);
      if (values.startTime) {
        const startStr = moment(values.startTime).format("HH:mm:ss");
        const endStr = moment(time).format("HH:mm:ss");
        handleChangeWithTouch("timeSlots")([`${startStr}-${endStr}`]);
        // Clear timeSlots error when both times are selected
        setFieldTouched("timeSlots", true, true);
        setFieldError("timeSlots", undefined);
      }
    }
  };

  console.log("errors add booking", errors);

  // Handle name input change
  const handleNameChange = (value) => {
    setFieldValue("name", value);
    setFieldTouched("name", false);
    setSearchTerm(value);

    // Only hide dropdown if the input is cleared
    if (!value || value.trim() === "") {
      setShowUserDropdown(false);
    } else {
      debouncedSearch(value);
    }
  };

  // Handle user selection from dropdown
  const handleUserSelect = (user) => {
    setFieldValue("name", user.userFullName || "");

    // Format and set phone number if available
    if (user.cellNumber) {
      // First, clean the phone number by removing any non-digit characters
      let phoneDigits = user.cellNumber.replace(/\D/g, "");

      // Check if we need to add a default country code
      if (phoneDigits.length < 12) {
        // Assuming Pakistan country code (92) if not present
        if (!phoneDigits.startsWith("92")) {
          phoneDigits = "92" + phoneDigits;
        }
      }

      // Set the properly formatted phone number
      setFieldValue("phoneNumber", phoneDigits);
      setFieldTouched("phoneNumber", false);
      setTimeout(() => {
        setFieldTouched("phoneNumber", true);
      }, 50);
    }

    // Set email if available
    if (user?.email) {
      setFieldValue("email", user?.email);
      setFieldTouched("email", true);
    }

    setShowUserDropdown(false);
    setUserSelected(true);
  };

  // Add a function to reset user selection
  const resetUserSelection = () => {
    setFieldValue("name", "");
    setFieldValue("phoneNumber", "");
    setFieldValue("email", "");
    setUserSelected(false);
    setFieldTouched("name", false);
    setFieldTouched("phoneNumber", false);
    setFieldTouched("email", false);
  };

  useEffect(() => {
    if (data) {
      console.log("Reaschedule ", data);
      console.log("locations", locations);

      console.log(
        "L=>>",
        locations?.find((ele) => ele?.locationName === data?.locationName)
          ?.locationId
      );
      let courtId = getSelectedCourt(
        locations?.find((ele) => ele?.locationName === data?.locationName)
          ?.locationId,
        data?.courtId
      )?.courtId;
      const details = data?.bookingPlayers?.find((data) => data?.isPrimary);
      console.log("Data in inside AddOrEditBookingModal", data);
      console.log(
        "getRelatedCourts(values?.location)",
        getRelatedCourts(
          locations?.find((ele) => ele?.locationName === data?.locationName)
            ?.locationId,
          data?.courtId
        )
      );

      setFieldValue("court", courtId);
      setFieldValue(
        "location",
        locations?.find((ele) => ele?.locationName === data?.locationName)
          ?.locationId
      );

      // Calculate duration based on time difference

      setFieldValue("bookingType", data?.bookingTypeId);
      setFieldValue("name", details?.playerFullName);
      setFieldValue("phoneNumber", details?.playerCellNumber);
      setFieldValue("email", details?.playerEmail);
      setFieldValue("bookingDate", data?.bookingDate);
      // Pre-fill time slots and total payment
      if (data?.bookingTypeId === 1 || data?.bookingTypeId === 5) {
        const startTime = moment(data?.bookingStartTime, "HH:mm:ss");
        const endTime = moment(data?.bookingEndTime, "HH:mm:ss");
        const durationInMinutes = endTime.diff(startTime, "minutes");
        const duration = durationInMinutes === 30 ? 30 : 60;
        setFieldValue("duration", duration);
        if (data?.corporateId) {
          setFieldValue("corporateId", data?.corporateId);
        }
        setFieldValue(
          "startTime",
          moment(data?.bookingStartTime, "HH:mm:ss").toDate()
        );
        setFieldValue(
          "endTime",
          moment(data?.bookingEndTime, "HH:mm:ss").toDate()
        );
        const timeSlotValue = `${convertToAmPm(
          data?.bookingStartTime
        )} - ${convertToAmPm(data?.bookingEndTime)}`;
        setFieldValue("timeSlots", [timeSlotValue]);
        setFieldValue("totalPayment", data?.bookingGrossAmount);
      } else {
        setFieldValue(
          "startTime",
          moment(data?.bookingStartTime, "HH:mm:ss").toDate()
        );
        setFieldValue(
          "endTime",
          moment(data?.bookingEndTime, "HH:mm:ss").toDate()
        );
        setFieldValue("totalPayment", data?.courtCharges?.toFixed(0));
      }
    }
  }, [data]);

  // Add this function to handle keyboard navigation

  // Modify the useEffect where you handle clicking outside to reset highlighted index
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowUserDropdown(false);
        setHighlightedIndex(-1); // Reset highlighted index when closing dropdown
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Reset highlighted index when search results change
  useEffect(() => {
    setHighlightedIndex(-1);
  }, [userList]);

  console.log("errors Refund and cancel", errors);
console.log("FLAG",getRelatedCourts(values?.location))
  return (
    <>
      <ModalSkeleton
        width="900px"
        show={show}
        setShow={setShow}
        title={"Reschedule Booking"}
        subTitle={subTitle}
      >
        <form onSubmit={handleSubmit} className={classes.form}>
          <Row className={classes.controlGrid}>
            <Col md={6}>
              <div className={classes.searchInputContainer}>
                <Input
                  leftIcon={
                    <LeftSide icon={<UserOutline className={classes.icon} />} />
                  }
                  customStyle={{ gap: "15px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label="Name"
                  placeholder="Enter name"
                  value={values?.name}
                  onChange={userSelected ? undefined : handleNameChange}
                  disabled={true}
                  errorText={touched?.name && errors?.name}
                  autocomplete="off"
                  rightIcon={
                    userSelected && (
                      <button
                        type="button"
                        className={classes.editUserButton}
                        onClick={resetUserSelection}
                        title="Remove user information"
                      >
                        <RxCross2 className={classes.editIcon} />
                      </button>
                    )
                  }
                />
              </div>
            </Col>
            <Col md={6}>
              <PhoneInput
                labelStyle={{ fontSize: "16px" }}
                label={"Phone Number"}
                placeholder="Enter Phone Number"
                value={values?.phoneNumber}
                onChange={
                  userSelected
                    ? undefined
                    : (e) => handleChangeWithTouch("phoneNumber")(e)
                }
                disabled={true}
                errorText={touched?.phoneNumber && errors?.phoneNumber}
              />
            </Col>
            <Col md={6}>
              <Input
                isOptional={true}
                leftIcon={<LeftSide icon={<DarkMailIcon />} />}
                customStyle={{ gap: "15px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="email"
                labelStyle={{ fontSize: "16px" }}
                label={"Email"}
                placeholder="Enter Email"
                value={values?.email}
                onChange={
                  userSelected ? undefined : handleChangeWithTouch("email")
                }
                disabled={true}
                errorText={touched?.email && errors?.email}
              />
            </Col>
            {locations?.length > 1 && (
              <Col md={6}>
                <Dropdown
                  options={locations?.map((data) => ({
                    label: data?.locationName,
                    value: data?.locationId,
                  }))}
                  icon={<LeftSide icon={<LocationIcon />} />}
                  customStyle={{ gap: "4px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  labelStyle={{ fontSize: "16px" }}
                  label={"Location"}
                  placeholder="Select Location"
                  value={values?.location}
                  onChange={handleChangeWithTouch("location")}
                  errorText={touched?.location && errors?.location}
                />
              </Col>
            )}
            <Col md={6}>
              <Dropdown
                options={getRelatedCourts(values?.location)?.filter(court => court?.courtStatusId
                  !== 2)}
                icon={
                  <LeftSide
                    icon={<BadmintonIcon className={classes.leftIcon} />}
                  />
                }
                customStyle={{ gap: "4px" }}
                inputStyle={{ paddingLeft: "0" }}
                type="number"
                labelStyle={{ fontSize: "16px" }}
                label={"Court"}
                placeholder="Select Court"
                value={values?.court}
                onChange={handleCourtChange}
                errorText={
                  touched?.court && !values?.court ? errors?.court : undefined
                }
              />
            </Col>

            <Col md={6}>
              <Dropdown
                options={getCombinedBookingOptions()}
                icon={
                  <LeftSide
                    icon={<BookingTypeIcon className={classes.leftIcon} />}
                  />
                }
                label={"Booking Type"}
                placeholder="Select Booking Type"
                value={values?.bookingType}
                onChange={(e) => {
                  setFieldValue("bookingType", e);
                  // If switching to corporate type, clear corporateId and mark as untouched
                  if (e === 5) {
                    setFieldValue("corporateId", null);
                    setFieldTouched("corporateId", false);
                  } else {
                    // When changing away from corporate, reset corporateId
                    setFieldValue("corporateId", null);
                  }
                }}
                errorText={touched?.bookingType && errors?.bookingType}
              />
            </Col>

            {/* Conditional Corporate Dropdown */}
            {values?.bookingType === 5 && (
              <Col md={6}>
                <div className={classes.corporateDropdownContainer}>
                  <Dropdown
                    icon={
                      <LeftSide
                        icon={<CorporateIcon className={classes.leftIcon} />}
                      />
                    }
                    label={"Select Corporation"}
                    options={corporateOptions.map((corp) => ({
                      label: corp.corporateName,
                      value: corp.corporateId,
                    }))}
                    value={values?.corporateId}
                    onChange={(e) => {
                      setFieldValue("corporateId", e);
                      // Delay marking as touched to allow validation to update first
                      setTimeout(() => {
                        setFieldTouched("corporateId", true, true); // The third parameter forces validation
                      }, 100);
                    }}
                    placeholder="Choose a Corporate"
                    errorText={touched?.corporateId && errors?.corporateId}
                  />
                  {values?.bookingType === 5 &&
                    !values?.corporateId &&
                    !touched?.corporateId && (
                      <div className={classes.requiredFieldNote}>
                        Required field
                      </div>
                    )}
                </div>
              </Col>
            )}

            <Col md={6}>
              <CalendarPicker
                label={"Booking Date"}
                placeholder="Select Booking Date"
                labelStyle={{ fontSize: "16px" }}
                value={values?.bookingDate}
                onChange={(e) => {
                  // Reset time-related fields when date changes
                  setFieldValue("timeSlots", []);
                  // setFieldValue("startTime", null);
                  // setFieldValue("endTime", null);
                  setFieldValue("totalPayment", 0);
                  handleChangeWithTouch("bookingDate")(
                    moment(e).format("YYYY-MM-DD")
                  );
                }}
                errorText={touched?.bookingDate && errors?.bookingDate}
                dateFormat="dd M `y"
              />
            </Col>
            <Col md={6}>
              <>
                <StartAndEndTime
                  label={"Time Slot"}
                  labelStyle={{ fontSize: "16px" }}
                  isOptional={true}
                  disabled={!values?.court || !values?.bookingDate}
                  onChange={handleTimeChange}
                  startTime={values?.startTime}
                  endTime={values?.endTime}
                  reset={
                    values?.bookingType !== 1 &&
                    (!values?.court || !values?.bookingDate)
                  }
                  errors={{
                    startTime: touched?.startTime && errors?.startTime,
                    endTime: touched?.endTime && errors?.endTime,
                  }}
                />
                {errors?.timeSlots &&
                  touched?.timeSlots &&
                  (!values?.startTime || !values?.endTime) && (
                    <Col md={12}>
                      <p className={"errorText"}>{errors?.timeSlots}</p>
                    </Col>
                  )}
              </>
            </Col>
            {values?.bookingType !== 1 && values?.bookingType !== 5 && (
              <Col md={6}>
                <Input
                  isOptional={true}
                  customStyle={{ gap: "4px" }}
                  inputStyle={{ paddingLeft: "0" }}
                  type="number"
                  disabled={
                    values?.bookingType === 1 || values?.bookingType === 5
                  }
                  leftIcon={
                    <LeftSide
                      disabled={true}
                      icon={
                        <ReceivePaymentIcon
                          className={clsx(classes.leftIcon, classes.iconSize)}
                        />
                      }
                      right={"Rs."}
                    />
                  }
                  labelStyle={{ fontSize: "16px" }}
                  label={"Total Payment"}
                  placeholder="Enter Total Payment"
                  value={calculatedAmount}
                  onChange={(e) => {
                    if (
                      (+e > +calculatedAmount && values?.bookingType === 1) ||
                      values?.bookingType === 5
                    ) {
                      handleChangeWithTouch("totalPayment")(0);
                      toast.warn(
                        "Discount amount should be less than total payment"
                      );
                      return;
                    } else {
                      handleChangeWithTouch("totalPayment")(e);
                    }
                  }}
                />
                <ShowCalculation
                  label={"Remaining Payment"}
                  value={`Rs. ${formatNumberWithCommas(remainingPayment)}`}
                />
              </Col>
            )}
          </Row>
          <ModalAction
            isApiCall={isApiCall}
            onCancel={() => {
              if (typeof setShow === "function") {
                setShow(false);
              }
            }}
            type="submit"
          />
        </form>
      </ModalSkeleton>
    </>
  );
};

export default RescheduleBookingModal;
